// @flow
import {
  UPDATE_LIST_POSTS,
  UPDATE_LIST_POSTS_STATUS 
} from '../../actions/posts'
import type {
  UPDATE_LIST_POSTS_TYPE,
  UPDATE_LIST_POSTS_STATUS_TYPE
} from '../../actions/posts'

type State = {
  allPosts: Object[],
  isFetching: boolean,
  error: null | string
}

const initialState: State = {
  allPosts: [],
  isFetching: true,
  error: null
}

type Action =
  | UPDATE_LIST_POSTS_TYPE
  | UPDATE_LIST_POSTS_STATUS_TYPE

export default function postsReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_LIST_POSTS: {
      const { allPosts } = action.payload
      return {
        ...state,
        allPosts
      }
    }
    case UPDATE_LIST_POSTS_STATUS: {
      const { isFetching, error } = action.payload
      return {
        ...state,
        isFetching,
        error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/posts/index.js